import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FabHoldReason, Grid, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { FabHoldReasonComponent } from './fab-hold-reason.component'

@Component({
    selector: 'app-fab-hold-reasons-list',
    templateUrl: './fab-hold-reasons-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class FabHoldReasonsListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() items: FabHoldReason[] = []
    @Output() modified = new EventEmitter<void>()

    grid: Grid<FabHoldReason>

    constructor() {
        super()
        this.grid = new Grid<FabHoldReason>(this.services)
            .setupModalEditing(
                this.services.data.fabHoldReasons,
                'Hold Reason',
                FabHoldReasonComponent,
                () => {
                    const reason = new FabHoldReason()
                    reason.id = crypto.randomUUID()
                    reason.active = true
                    reason.sortOrder = 0
                    return reason
                },
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.name])
            .isReadOnly(true)

        this.grid.itemAdded.on(() => this.modified.emit())
        this.grid.itemEdited.on(() => this.modified.emit())
        this.grid.itemsDeleted.on(() => this.modified.emit())
        this.initialLoadingComplete()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.grid.items = this.items || []
        }
    }
}
